import React, { useLayoutEffect } from "react";
import PropTypes from "prop-types";
import Immutable from "immutable";
import { connect } from "react-redux";
import { BUS_CHASSIS_PATH } from "../../../../config/paths";
import { breadcrumbsPropTypes, matchPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import Content from "../../../layout/Content";
import Loader from "../../../common/Loader";
import NoDataResource from "../../../common/resource/NoDataResource";
import InternalResource from '../../../common/resource/InternalResource';
import BusChassisBasicInformationResource from "./resources/BusChassisBasicInformationResource";
import BusChassisToolbar from "./BusChassisToolbar";
import { clearBusChassis, getBusChassis } from "../../../../actions";

export const BusChassis = ({
    breadcrumbs,
  dispatchGetBusChassis,
  dispatchClearBusChassis,
  match: {
    params: { id: busChassisId },
  },
  loading,
  busChassis,
}) => {
  useLayoutEffect(() => {
    dispatchGetBusChassis({ busChassisId });

    return () => dispatchClearBusChassis();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (busChassis.isEmpty())
    content = <NoDataResource returnPage={BUS_CHASSIS_PATH} />;
  else {
    const busChassisJson = busChassis.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <BusChassisBasicInformationResource {...busChassisJson} />
        <InternalResource id={busChassisJson.id}
          createDate={busChassisJson.createDate}
          lastUpdate={busChassisJson.lastUpdate}/>
      </>
    );

    toolbar = <BusChassisToolbar busChassisId={busChassisJson.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Chasís"
      content={content}
    />
  );
};

BusChassis.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearBusChassis: PropTypes.func.isRequired,
  dispatchGetBusChassis: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  busChassis: PropTypes.instanceOf(Immutable.Map).isRequired,
};

BusChassis.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearBusChassis: clearBusChassis,
  dispatchGetBusChassis: getBusChassis
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Chasís',
      href: BUS_CHASSIS_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  busChassis: BusUnit.BusChassis.getIn(['current', 'content']),
  loading: !BusUnit.BusChassis.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(BusChassis);